import React from "react";

const SingleItem = ({
    data,
    index,
    paginateData,
}) => {
    const orders = data?.orders || [];

    const serialNumber =
        (Number(paginateData?.page || 1) - 1) *
        Number(paginateData?.limit || 10) +
        index +
        1;

    return (
        <>
            {orders.length > 0 ? (
                orders.map((order, orderIndex) => (
                    <tr key={order?._id || orderIndex}>
                        <td data-label="S.N.">
                            {orderIndex + 1}
                        </td>

                        <td data-label="Type">
                            {order?.type || "—"}
                        </td>

                        <td data-label="Order #">
                            {data?.orderNo || order?.orderNo || "—"}
                        </td>

                        <td data-label="Manage Crypto">
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm mb-0">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th className="text-center">
                                                Quantity
                                            </th>
                                            <th className="text-end">
                                                Price
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {order?.products?.length > 0 ? (
                                            order.products.map(
                                                (item, productIndex) => (
                                                    <tr
                                                        key={
                                                            item?._id ||
                                                            productIndex
                                                        }
                                                    >
                                                        <td>
                                                            {item?.productInfo
                                                                ?.name ||
                                                                item?.productId
                                                                    ?.name ||
                                                                "N/A"}
                                                        </td>

                                                        <td className="text-center">
                                                            {item?.quantity ?? 0}
                                                        </td>

                                                        <td className="text-end">
                                                            {Number(
                                                                item?.price || 0
                                                            ).toFixed(2)}
                                                            $
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="3"
                                                    className="text-center"
                                                >
                                                    No products found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </td>

                        <td data-label="Order Amount">
                            {Number(order?.subtotal || 0).toFixed(2)}$
                        </td>

                        <td data-label="Profit %">
                            {order?.profit ?? 0}%
                        </td>

                        <td data-label="Profit Amount">
                            {Number(
                                order?.profitAmount || 0
                            ).toFixed(2)}$
                        </td>

                        <td data-label="Total With Profit">
                            {Number(
                                order?.totalWithProfit || 0
                            ).toFixed(2)}$
                        </td>

                        <td data-label="Status">
                            {order?.status ? (
                                <span className="badge badge--success text-success">
                                    Paid
                                </span>
                            ) : (
                                <span className="badge badge--warning text-warning">
                                    Unpaid
                                </span>
                            )}
                        </td>


                    </tr>
                ))
            ) : (
                <tr>
                    <td>{serialNumber}</td>
                    <td>—</td>
                    <td>{data?.orderNo || "—"}</td>
                    <td>
                        {data?.orderSet?.name || "—"} /{" "}
                        {data?.platformType?.name || "—"}
                    </td>
                    <td>{Number(data?.totalSubtotal || 0).toFixed(2)}$</td>
                    <td>—</td>
                    <td>—</td>
                    <td>—</td>
                    <td>
                        {data?.status ? "Paid" : "Unpaid"}
                    </td>
                    <td>—</td>
                </tr>
            )}
        </>
    );
};

export default SingleItem;